import React, { useState } from 'react';

const BMIModal = ({ isOpen, onClose }) => {
    const [heightFeet, setHeightFeet] = useState('');
    const [heightInches, setHeightInches] = useState('');
    const [weightLbs, setWeightLbs] = useState('');
    const [bmi, setBmi] = useState(null);

    const calculateBMI = () => {
        const feet = parseFloat(heightFeet);
        const inches = parseFloat(heightInches);
        const weight = parseFloat(weightLbs);

        if (isNaN(feet) || isNaN(inches) || isNaN(weight)) return;

        const totalInches = feet * 12 + inches;
        const bmiValue = (weight / (totalInches * totalInches)) * 703;
        setBmi(bmiValue.toFixed(1));
    };

    const getBMICategory = (bmi) => {
        if (bmi < 18.5) return "Underweight";
        if (bmi < 24.9) return "Normal weight";
        if (bmi < 29.9) return "Overweight";
        return "Obese";
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-xl p-6 w-96 shadow-lg relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
                    aria-label="Close"
                >
                    ✕
                </button>
                <h2 className="text-xl font-bold mb-4 text-center">BMI Calculator</h2>
                <div className="mb-3">
                    <label className="block text-sm mb-1">Height:</label>
                    <div className="flex gap-2">
                        <input
                            type="number"
                            className="w-1/2 border rounded p-2"
                            value={heightFeet}
                            onChange={(e) => setHeightFeet(e.target.value)}
                            placeholder="Feet"
                        />
                        <input
                            type="number"
                            className="w-1/2 border rounded p-2"
                            value={heightInches}
                            onChange={(e) => setHeightInches(e.target.value)}
                            placeholder="Inches"
                        />
                    </div>
                </div>

                <div className="mb-3">
                    <label className="block text-sm mb-1">Weight (lbs):</label>
                    <input
                        type="number"
                        className="w-full border rounded p-2"
                        value={weightLbs}
                        onChange={(e) => setWeightLbs(e.target.value)}
                        placeholder="e.g. 160"
                    />
                </div>

                <button
                    onClick={calculateBMI}
                    className="bg-blue-600 text-white rounded w-full py-2 mb-3 hover:bg-blue-700 transition"
                >
                    Calculate BMI
                </button>

                {bmi && (
                    <div className="text-center">
                        <p className="font-semibold text-lg">Your BMI: <span className="text-blue-600">{bmi}</span></p>
                        <p className="text-sm text-gray-600">
                            Category: <span className="font-medium">{getBMICategory(bmi)}</span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BMIModal;
